import SiteHeader from '@/components/header'
import SiteFooter from '@/components/footer'
import SiteMenus from '@/components/menus'
import { mapGetters, mapActions } from 'vuex'
import menus from '@/utils/menus'
import user from '@/api/user'
import publisher from '@/api/publisher'
import dict from '@/api/dict'
import file from '@/api/file'

export default {
  components: {
    SiteHeader,
    SiteFooter,
    SiteMenus
  },
  data() {
    return {
      menus
    }
  },
  computed: {
    ...mapGetters({
      showMenus: 'getShowMenus',
      publisherId: 'getPublisherId',
      language: 'getLanguage',
      publisherInfo: 'getPublisherInfo',
      user: 'getUser',
      loading: 'getLoading'
    })
  },
  // watch: {
  //   //监听相同路由下参数变化的时候，从而实现异步刷新
  //   $route() {
  //     if (this.user.completed) {
  //       this.$message.error({
  //         title: 'Error',
  //         content: 'Please complete your personal information first'
  //       })
  //       this.$router.push('/user-manage/profile')
  //     }
  //   }
  // },
  async mounted() {
    await this.getInfo()
    await this.getPublisherInfo()
    this.getDomain()
    this.checkDict()
  },
  methods: {
    ...mapActions([
      'updateUser',
      'updateLanguage',
      'updatePublisherId',
      'updatePublisherInfo',
      'updateDomain',
      'updateToken',

      'updateCountry',
      'updateGender',
      'updateTitle',
      'updateEditorialBoard',
      'updateGuestEditor',
      'updateManagementTeam',

      'updateAttachmentType',
      'updateDegree',
      'updateHighestDegree',
      'updateManuscriptType',
      'updateReviewFrequency',
      'updateReviewType',
      'updateReviewRefuse',
      'updateIndexedDatabase',
      'updateSectionEditor'
    ]),
    async getInfo() {
      if (!localStorage.getItem('token')) {
        return
      }
      const res = await user.info()
      res.roles = res.roleList.map(item => {
        return item.type
      })
      this.updateToken(localStorage.getItem('token'))
      this.updateUser(res)
      this.updatePublisherId(res.publisherId)
    },
    async getPublisherInfo() {
      this.updatePublisherInfo(await publisher.query(this.publisherId))
    },
    async checkDict() {
      const historyDictVersion = localStorage.getItem('dict-version')
      const dictVersion = await dict.getVersion()
      if (dictVersion != historyDictVersion) {
        localStorage.setItem('dict-version', dictVersion)
        await this.getDict()
      }
      this.setDict()
    },
    async getDict() {
      const dictData = await dict.getAll()
      localStorage.setItem('dict', JSON.stringify(dictData))
    },
    setDict() {
      const dict = JSON.parse(localStorage.getItem('dict'))
      this.updateCountry(dict.COUNTRY)
      // this.updateGender(dict.gender)
      this.updateTitle(dict.TITLE)
      this.updateEditorialBoard(dict.EDITORIAL_BOARD_IDENTITY)
      this.updateGuestEditor(dict.GUEST_EDITOR_IDENTITY)
      this.updateManagementTeam(dict.MANAGEMENT_TEAM_ROLE)

      // this.updateAttachmentType(dict['attachment-type'])
      this.updateDegree(dict.DEGREE)
      this.updateHighestDegree(dict.HIGHEST_DEGREE)
      this.updateManuscriptType(dict.ATYPE)
      this.updateReviewFrequency(dict.REVIEW_FREQUENCY)
      this.updateReviewType(dict.REVIEWER_BOARD_IDENTITY)
      this.updateReviewRefuse(dict.REVIEWER_REFUSE_REASON)
      // this.updateIndexedDatabase(dict['database_inclusion'])
      this.updateSectionEditor(dict.SECTION_EDITOR_IDENTITY)
    },
    async getDomain() {
      const domain = await file.domain()
      this.updateDomain(domain)
    }
  }
}
